<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<div class="table-container">
    <!--    Шапка с табами    -->
    <div class="widget-container head-grid-tab"
         [class.selected]="mainTabs === 'all'"
         (click)="changeMainTab('all')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>{{ 'INDEX_PAGE.DOCUMENTS.TABS.ALL' | translate }} </h2>
            </div>
        </div>
    </div>
    <div class="widget-container head-grid-tab"
         [class.selected]="mainTabs === 'sign'"
         (click)="changeMainTab('sign')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>{{ 'INDEX_PAGE.DOCUMENTS.TABS.SIGN' | translate }} </h2>
                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.sign }}
                        </span>
                    } @else {
                        <span>N/A</span>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="widget-container head-grid-tab"
         [class.selected]="mainTabs === 'visa'"
         (click)="changeMainTab('visa')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>{{ 'INDEX_PAGE.DOCUMENTS.TABS.VISA' | translate }} </h2>
                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.approver }}
                        </span>
                    } @else {
                        <span>N/A</span>
                    }
                </div>
            </div>
        </div>
    </div>
    <!--  Шапка END  -->


    @switch (mainTabs) {
        @case ('all') {
            <div class="widget-container column-3">
                @if (foldersTree) {
                    <div class="widget-body">
                        <div class="tree-container">

                            <!--    Колонка с папками    -->
                            <div class="tree-columns first">
                                <div class="column-header">
                                    <h2>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.FOLDERS' | translate }} </h2>
                                    <div class="direction-arrow">
                                        <i class="ri-arrow-right-fill"></i>
                                    </div>
                                </div>

                                @for (folder of foldersTree; track folder.folder.id) {
                                    <ng-container
                                            *ngTemplateOutlet="folderItemTemplate; context: {folder: folder}"
                                    ></ng-container>
                                } @empty {
                                    <span>{{ 'EMPTY_LISTS.DOCS' | translate }}</span>
                                }

                                <!--    Шаблон рендера папок    -->
                                <ng-template #folderItemTemplate
                                             let-folder="folder"
                                >
                                    <div class="column-item"
                                         [class.selected]="selectedFolder && selectedFolder.folder.id === folder.folder.id"
                                         [class.opened]="openFolderInfo"
                                         (click)="getCollections(folder);
                                                    collapseFolders[folder.folder.id] = !collapseFolders[folder.folder.id]"
                                    >
                                        <span>
                                            <i class="ri-folder-3-fill"></i>
                                            {{ folder.folder.name }}
                                        </span>

                                        <span>
                                            @if (selectedFolder && selectedFolder.folder.id === folder.folder.id) {
                                                <i class="ri-information-line"
                                                   (click)="$event.stopPropagation(); openFolderInfo = !openFolderInfo"
                                                ></i>
                                            }

                                            @if (folder.children.length) {
                                                @if (collapseFolders[folder.folder.id]) {
                                                    <i class="ri-arrow-down-s-fill"></i>
                                                } @else {
                                                    <i class="ri-arrow-right-s-fill"></i>
                                                }
                                            }
                                        </span>
                                    </div>

                                    @if (openFolderInfo && selectedFolder && folder.folder.id === selectedFolder.folder.id) {
                                        <div class="item-info">
                                            <h2>{{ selectedFolder.folder.name }}</h2>
                                            <div [innerHTML]="selectedFolder.folder.description"></div>
                                        </div>
                                    }

                                    @if (collapseFolders[folder.folder.id]) {
                                        @for (childrenFolder of folder.children; track childrenFolder.folder.id) {
                                            <div class="sub-item">
                                                <ng-container
                                                        *ngTemplateOutlet="folderItemTemplate;
                                                    context:{folder: childrenFolder}"
                                                ></ng-container>
                                            </div>
                                        }
                                    }
                                </ng-template>

                            </div>

                            <!--    Колонка с коллекциями    -->
                            <div class="tree-columns">
                                <div class="column-header">
                                    <h2>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.COLLECTIONS' | translate }} </h2>
                                    <div class="direction-arrow">
                                        <i class="ri-arrow-right-fill"></i>
                                    </div>
                                </div>

                                @for (collection of collections; track collection.collection.id) {
                                    <div class="column-item"
                                         [class.selected]="selectedCollection &&
                                                        selectedCollection.collection.id === collection.collection.id"
                                         [class.opened]="openCollectionInfo"
                                         (click)="getFiles(collection)"
                                    >
                                        <span>
                                            <i class="ri-folder-shield-fill"></i>
                                            {{ collection.collection.name }}
                                        </span>

                                        @if (selectedCollection &&
                                        selectedCollection.collection.id === collection.collection.id) {
                                            <i class="ri-information-line"
                                               (click)="$event.stopPropagation(); openCollectionInfo = !openCollectionInfo"
                                            ></i>
                                        }
                                    </div>

                                    @if (openCollectionInfo && selectedCollection &&
                                    selectedCollection.collection.id === collection.collection.id) {
                                        <div class="item-info">
                                            <h2>{{ selectedCollection.collection.name }}</h2>
                                            <div [innerHTML]="selectedCollection.collection.description"></div>
                                            <p>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.TOTAL_SIGNED' | translate }}
                                                {{ selectedCollection.collection.signed_documents }}
                                            </p>
                                            <p>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.COLLECTION_CLOSED.TEXT' | translate }}
                                                {{
                                                    (selectedCollection.collection.is_locked ?
                                                        'INDEX_PAGE.DOCUMENTS.TEXT.COLLECTION_CLOSED.YES' :
                                                        'INDEX_PAGE.DOCUMENTS.TEXT.COLLECTION_CLOSED.NO') | translate
                                                }}
                                            </p>
                                        </div>
                                    }
                                } @empty {
                                    <span>{{ 'EMPTY_LISTS.DOCS' | translate }}</span>
                                }

                                @if (selectedFolder) {
                                    <app-component-pagination
                                            [pagination]="collectionsPagination"
                                            [totalPages]="collectionsPagination.pages"

                                            (page)="collectionsPagination.current_page = $event; getCollections(selectedFolder)"
                                    ></app-component-pagination>
                                }
                            </div>

                            <!--    Колонка с файлами    -->
                            <div class="tree-columns last">
                                <div class="column-header">
                                    <h2>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.FILES' | translate }}</h2>
                                </div>

                                @for (file of files; track file.key) {
                                    <div class="column-item"
                                         [class.selected]="selectedFile && selectedFile.key === file.key"
                                         [class.opened]="selectedFile"
                                         (click)="selectFile(file)"
                                    >
                                        <span>
                                            @switch (file.name.split('.')[1]) {
                                                @case ('pdf') {
                                                    <i class="ri-file-pdf-2-fill"></i>
                                                }
                                                @case ('doc') {
                                                    <i class="ri-file-word-fill"></i>
                                                }
                                                @case ('docx') {
                                                    <i class="ri-file-word-fill"></i>
                                                }
                                                @case ('docm') {
                                                    <i class="ri-file-word-fill"></i>
                                                }
                                                @case ('xls') {
                                                    <i class="ri-file-excel-fill"></i>
                                                }
                                                @case ('xlsx') {
                                                    <i class="ri-file-excel-fill"></i>
                                                }
                                                @default {
                                                    <i class="ri-file-fill"></i>
                                                }
                                            }
                                            {{ file.name }}
                                        </span>

                                        <i [matTooltip]="'INDEX_PAGE.DOCUMENTS.TEXT.OPEN_FILE' | translate"
                                           (click)="goTo($event, file, docDialog)"
                                           class="ri-eye-line"
                                        ></i>
                                    </div>

                                    @if (selectedFile && selectedFile.key === file.key) {
                                        <div class="item-info">
                                            <h2>{{ selectedFile.name }}</h2>
                                            <div [innerHTML]="selectedFile.description"></div>
                                            <p>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.VERSIONS' | translate }} {{ selectedFile.versions.length }}</p>

                                            <div class="button-info-container">
                                                <button (click)="goTo($event, file, docDialog)">
                                                    <i class="ri-eye-line"></i>
                                                    {{ 'INDEX_PAGE.DOCUMENTS.TEXT.OPEN_FILE' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    }
                                }

                                @if (selectedCollection) {
                                    <app-component-pagination
                                            [pagination]="filesPagination"
                                            [totalPages]="filesPagination.pages"

                                            (page)="filesPagination.current_page = $event; getFiles(selectedCollection)"
                                    ></app-component-pagination>
                                }
                            </div>
                        </div>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        }
        @case ('sign') {
            <div class="widget-container column-3 center">
                <div class="widget-header">
                    <h2>{{ 'INDEX_PAGE.DOCUMENTS.WIDGET_HEADERS.FOR_SIGN' | translate }}</h2>
                </div>
                @if (filesForSign) {
                    <div class="widget-body tree-container">
                        <div class="tree-columns full">
                            @for (file of filesForSign; track file.key) {
                                <div class="column-item"
                                     [class.selected]="selectedSignFile && selectedSignFile.key === file.key"
                                     [class.opened]="selectedSignFile && selectedSignFile.key === file.key"
                                     (click)="getFileMembers(file, 'sign')"
                                >
                            <span>
                                @switch (file.name.split('.')[1]) {
                                    @case ('pdf') {
                                        <i class="ri-file-pdf-2-fill"></i>
                                    }
                                    @case ('doc') {
                                        <i class="ri-file-word-fill"></i>
                                    }
                                    @case ('docx') {
                                        <i class="ri-file-word-fill"></i>
                                    }
                                    @case ('docm') {
                                        <i class="ri-file-word-fill"></i>
                                    }
                                    @case ('xls') {
                                        <i class="ri-file-excel-fill"></i>
                                    }
                                    @case ('xlsx') {
                                        <i class="ri-file-excel-fill"></i>
                                    }
                                    @default {
                                        <i class="ri-file-fill"></i>
                                    }
                                }
                                {{ file.name }}
                            </span>
                                </div>

                                @if (selectedSignFile && selectedSignFile.key === file.key) {
                                    <div class="item-info">
                                        <h2>{{ selectedSignFile.name }}</h2>
                                        <div [innerHTML]="selectedSignFile.description"></div>
                                        <div>
                                            <span>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.SIGNERS' | translate }}</span>
                                            <div class="avatars">
                                                @for (user of selectedSignFile.signers_guids; track user.member_guid) {
                                                    @if (user.user) {
                                                        <app-avatar
                                                                [profile]="user.user"
                                                                [size]="'mini'"
                                                                [avatarFrame]="true"
                                                                [successFrame]="user.sign"
                                                        ></app-avatar>
                                                    }
                                                }
                                            </div>
                                        </div>

                                        <div class="button-info-container">
                                            <button (click)="goTo($event, file, docDialog)">
                                                <i class="ri-eye-line"></i>
                                                {{ 'INDEX_PAGE.DOCUMENTS.TEXT.OPEN_FILE' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                }
                            } @empty {
                                <span>{{ 'EMPTY_LISTS.DOCS' | translate }}</span>
                            }
                        </div>
                    </div>
                    <app-component-pagination
                            [pagination]="signPagination"
                            [totalPages]="signPagination.pages"

                            (page)="signPagination.current_page = $event; getFilesForSign()"
                    ></app-component-pagination>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        }
        @case ('visa') {
            <div class="widget-container column-3 center">
                <div class="widget-header">
                    <h2>{{ 'INDEX_PAGE.DOCUMENTS.WIDGET_HEADERS.FOR_VISA' | translate }}</h2>
                </div>
                @if (filesForVisa) {
                    <div class="widget-body tree-container">
                        <div class="tree-columns full">
                            @for (file of filesForVisa; track file.key) {
                                <div class="column-item"
                                     [class.selected]="selectedVisaFile && selectedVisaFile.key === file.key"
                                     [class.opened]="selectedVisaFile && selectedVisaFile.key === file.key"
                                     (click)="getFileMembers(file, 'visa')"
                                >
                            <span>
                                @switch (file.name.split('.')[1]) {
                                    @case ('pdf') {
                                        <i class="ri-file-pdf-2-fill"></i>
                                    }
                                    @case ('doc') {
                                        <i class="ri-file-word-fill"></i>
                                    }
                                    @case ('docx') {
                                        <i class="ri-file-word-fill"></i>
                                    }
                                    @case ('docm') {
                                        <i class="ri-file-word-fill"></i>
                                    }
                                    @case ('xls') {
                                        <i class="ri-file-excel-fill"></i>
                                    }
                                    @case ('xlsx') {
                                        <i class="ri-file-excel-fill"></i>
                                    }
                                    @default {
                                        <i class="ri-file-fill"></i>
                                    }
                                }
                                {{ file.name }}
                            </span>
                                </div>

                                @if (selectedVisaFile && selectedVisaFile.key === file.key) {
                                    <div class="item-info">
                                        <h2>{{ selectedVisaFile.name }}</h2>
                                        <div [innerHTML]="selectedVisaFile.description"></div>
                                        <div>
                                            <span>{{ 'INDEX_PAGE.DOCUMENTS.TEXT.VISORS' | translate }}</span>
                                            <div class="avatars">
                                                @for (user of selectedVisaFile.approvers_guids; track user.member_guid) {
                                                    @if (user.user) {
                                                        <app-avatar
                                                                [profile]="user.user"
                                                                [size]="'mini'"
                                                                [avatarFrame]="true"
                                                                [successFrame]="user.sign"
                                                        ></app-avatar>
                                                    }
                                                }
                                            </div>
                                        </div>

                                        <div class="button-info-container">
                                            <button (click)="goTo($event, file, docDialog)">
                                                <i class="ri-eye-line"></i>
                                                {{ 'INDEX_PAGE.DOCUMENTS.TEXT.OPEN_FILE' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                }
                            } @empty {
                                <span>{{ 'EMPTY_LISTS.DOCS' | translate }}</span>
                            }
                        </div>
                    </div>
                    <app-component-pagination
                            [pagination]="visaPagination"
                            [totalPages]="visaPagination.pages ?? 1"

                            (page)="visaPagination.current_page = $event; getFilesForVisa()"
                    ></app-component-pagination>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        }
    }
</div>

<ng-template #docDialog>
    <div>
        <app-component-doc-view [fileUkey]="fileKey"
                                [isOpenModal]="true"
        ></app-component-doc-view>
    </div>
</ng-template>
